import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getStockReturnApiErrorMessage(error, fallback = '操作失敗') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'STOCK_RETURN_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到退料單資料';
  }

  if (code === 'INVENTORY_STOCK_LOCKED') {
    return data?.message || '庫存項已被其他單據鎖定';
  }

  if (code === 'INSUFFICIENT_INVENTORY_STOCK'
    || code === 'INSUFFICIENT_AVAILABLE_INVENTORY_STOCK') {
    return data?.message || '可用庫存不足，無法退料';
  }

  if (data?.message) {
    return data.message;
  }

  if (code) {
    return `${fallback}（${code}）`;
  }

  return fallback;
}

export function isStockReturnVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
